angular.module('aprima-legacy-common').run(['CustomModuleRunService', function(CustomModuleRunService) {
    'use strict';
    CustomModuleRunService.add(['Bridge', '$transitions', 'AppRoutes', '_', '$uibModalStack', function (Bridge, $transitions, AppRoutes, _, $uibModalStack) {

        $transitions.onSuccess({}, function bridgeSetupPage(transition) {
            $uibModalStack.dismissAll('pageTransition');

            var toState = transition.targetState() || {};
            var toStateName = toState && toState.name() || '';
            var appRoute = _.find(AppRoutes, {state: toStateName});

            if (appRoute && appRoute.nativeSettings && !appRoute.nativeSettings.ctrlSetsUpPage) {
                Bridge.setupPage(appRoute.nativeSettings);
            }
        });
    }]);
}]);

